module.exports = __webpack_public_path__ + "components/country-flag/static/ch-2db609c43667c9a03fe3b15380874c09.svg";